"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareBrandingConfig = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const set_1 = __importDefault(require("lodash/set"));
const default_styles_1 = require("src/components/app/themes/default.styles");
const morda_1 = require("src/styles/skins/morda");
const format_1 = require("./format");
const SKINS = {
    'portal': morda_1.MORDA_SKIN
};
// eslint-disable-next-line complexity
function prepareBrandingForUnderlay(branding) {
    var _a;
    const transparency = (_a = branding.underlay) === null || _a === void 0 ? void 0 : _a.transparency;
    if (transparency && !branding.underlay.bg) {
        branding.underlay.bg = (0, format_1.hexToRgba)(default_styles_1.LIGHT_THEME_PAGE_BG_COLOR, 1 - transparency / 100);
    }
    if (!branding.darkTheme)
        return;
    if (!branding.darkTheme.underlay) {
        branding.darkTheme.underlay = {};
    }
    if (!branding.darkTheme.underlay.bg) {
        const darkTransparency = branding.darkTheme.underlay.transparency || transparency;
        branding.darkTheme.underlay.bg = darkTransparency ?
            (0, format_1.hexToRgba)(default_styles_1.DARK_THEME_PAGE_BG_COLOR, 1 - darkTransparency / 100) :
            default_styles_1.DARK_THEME_PAGE_BG_COLOR;
    }
}
// eslint-disable-next-line complexity, max-statements
function prepareBrandingForInput(branding) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (!branding.darkTheme || !branding.input)
        return;
    if (branding.input.autogrow !== undefined && ((_a = branding.darkTheme.input) === null || _a === void 0 ? void 0 : _a.autogrow) === undefined) {
        (0, set_1.default)(branding, 'darkTheme.input.autogrow', branding.input.autogrow);
    }
    if (((_b = branding.input.border) === null || _b === void 0 ? void 0 : _b.type) && !((_d = (_c = branding.darkTheme.input) === null || _c === void 0 ? void 0 : _c.border) === null || _d === void 0 ? void 0 : _d.type)) {
        (0, set_1.default)(branding, 'darkTheme.input.border.type', branding.input.border.type);
    }
    if (((_e = branding.input.restriction) === null || _e === void 0 ? void 0 : _e.hidden) !== undefined &&
        ((_g = (_f = branding.darkTheme.input) === null || _f === void 0 ? void 0 : _f.restriction) === null || _g === void 0 ? void 0 : _g.hidden) === undefined) {
        (0, set_1.default)(branding, 'darkTheme.input.restriction.hidden', branding.input.restriction.hidden);
    }
    if (((_j = (_h = branding.input.mobile) === null || _h === void 0 ? void 0 : _h.restriction) === null || _j === void 0 ? void 0 : _j.hidden) !== undefined &&
        ((_l = (_k = branding.darkTheme.input) === null || _k === void 0 ? void 0 : _k.restriction) === null || _l === void 0 ? void 0 : _l.hidden) === undefined) {
        (0, set_1.default)(branding, 'darkTheme.input.mobile.restriction.hidden', branding.input.mobile.restriction.hidden);
    }
    if (branding.input.placeholders && !((_m = branding.darkTheme.input) === null || _m === void 0 ? void 0 : _m.placeholders)) {
        (0, set_1.default)(branding, 'darkTheme.input.placeholders', branding.input.placeholders);
    }
}
function prepareBrandingForChoice(branding) {
    var _a;
    if (!branding.darkTheme || !branding.choice)
        return;
    if (branding.choice.answerWithText && !((_a = branding.darkTheme.choice) === null || _a === void 0 ? void 0 : _a.answerWithText)) {
        (0, set_1.default)(branding, 'darkTheme.choice.answerWithText', branding.choice.answerWithText);
    }
}
function prepareBrandingForSpinner(branding) {
    if (!branding.darkTheme)
        return;
    if (branding.spinner && !branding.darkTheme.spinner) {
        (0, set_1.default)(branding, 'darkTheme.spinner', branding.spinner);
    }
}
// eslint-disable-next-line complexity, max-statements
function prepareBrandingForRating(branding) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!branding.darkTheme || !branding.rating)
        return;
    if (branding.rating.starType && !((_a = branding.darkTheme.rating) === null || _a === void 0 ? void 0 : _a.starType)) {
        (0, set_1.default)(branding, 'darkTheme.rating.starType', branding.rating.starType);
    }
    if (branding.rating.borderWidth && !((_b = branding.darkTheme.rating) === null || _b === void 0 ? void 0 : _b.borderWidth)) {
        (0, set_1.default)(branding, 'darkTheme.rating.borderWidth', branding.rating.borderWidth);
    }
    if (!branding.rating.colors)
        return;
    if (branding.rating.colors.borderActive && !((_d = (_c = branding.darkTheme.rating) === null || _c === void 0 ? void 0 : _c.colors) === null || _d === void 0 ? void 0 : _d.borderActive)) {
        (0, set_1.default)(branding, 'darkTheme.rating.colors.borderActive', branding.rating.colors.borderActive);
    }
    if (branding.rating.colors.borderInactive && !((_f = (_e = branding.darkTheme.rating) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.borderInactive)) {
        (0, set_1.default)(branding, 'darkTheme.rating.colors.borderInactive', branding.rating.colors.borderInactive);
    }
    if (branding.rating.colors.fillActive && !((_h = (_g = branding.darkTheme.rating) === null || _g === void 0 ? void 0 : _g.colors) === null || _h === void 0 ? void 0 : _h.fillActive)) {
        (0, set_1.default)(branding, 'darkTheme.rating.colors.fillActive', branding.rating.colors.fillActive);
    }
    if (branding.rating.colors.fillInactive && !((_k = (_j = branding.darkTheme.rating) === null || _j === void 0 ? void 0 : _j.colors) === null || _k === void 0 ? void 0 : _k.fillInactive)) {
        (0, set_1.default)(branding, 'darkTheme.rating.colors.fillInactive', branding.rating.colors.fillInactive);
    }
}
// eslint-disable-next-line import/prefer-default-export
function prepareBrandingConfig(branding, supportDarkMode) {
    var _a;
    const skin = Object.assign({}, SKINS[branding.skin]);
    const darkTheme = supportDarkMode
        ? Object.assign({}, (_a = SKINS[branding.skin]) === null || _a === void 0 ? void 0 : _a.darkTheme, branding.darkTheme)
        : undefined;
    const prepared = (0, cloneDeep_1.default)(Object.assign(Object.assign(Object.assign({}, skin), branding), { darkTheme }));
    prepareBrandingForUnderlay(prepared);
    prepareBrandingForInput(prepared);
    prepareBrandingForChoice(prepared);
    prepareBrandingForSpinner(prepared);
    prepareBrandingForRating(prepared);
    return prepared;
}
exports.prepareBrandingConfig = prepareBrandingConfig;
